import { Inject, Injectable } from '@angular/core';
import { CrudService } from 'src/app/core/services/crud.service';
import { QueryService } from 'src/app/core/services/query.service';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { IWaterSupplyZone } from './water-supply-zone.model';
import { WATERSUPPLYZONE_ENDPOINT, WATERSUPPLYZONE_QUERY_SERVICE_INSTANCE } from './water-supply-zone.config';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, retry, throwError } from 'rxjs';
import {environment} from 'src/environments/environment';
import { LayerGeografici } from './models/layer-geografici';
@Injectable({
  providedIn: 'root'
})
export class WaterSupplyZoneService extends CrudService<IWaterSupplyZone> {

  constructor(
    @Inject(WATERSUPPLYZONE_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<IWaterSupplyZone>,
    @Inject(ApiService) protected override readonly api: ApiService,
    @Inject(SnackbarService) protected override readonly snackbar: SnackbarService,
    private http: HttpClient,
  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(WATERSUPPLYZONE_ENDPOINT, api, snackbar);
  }
  sendFile(file: File) {
    console.log(file);
    
    const formData = new FormData();
    formData.append('file', file); // 👈 Aggiunge il file a FormData

    //http://localhost:8000/shapefile/convert
    return this.http.post<any>(environment.shapeFile, formData, {
      responseType: 'json'
    }).pipe(
      retry(0),
      catchError(error => this.handleError(error))
    );
  }

    invioJsonWsz(dati:any){
      return this.http.post(environment.apiWszUrl+"/wsz", dati).pipe(
        retry(0),
        catchError(error => this.handleError(error))
      );
    }


    layerJsonWsz(page: number | string, size:number | string, layer:string,dati:any): Observable<any> {
/*       return this.http.post<LayerGeografici>(environment.apiWszUrl+`/tendina/all?page=${page}&size=${size}&multiPolygonNomeEntita=${layer}`, dati).pipe(
        retry(0),
        catchError(error => this.handleError(error))
      ); */
      console.log(dati)
      return this.http.get<any>(environment.apiWszUrl+`/tendina/all?page=${page}&size=${size}&multiPolygonNomeEntita=${layer}&${dati}`).pipe(
        retry(0),
        catchError(error => this.handleError(error))
      );
    }

    geoJsonWsz<LayerGeografici>( id:number | string, layer:string): Observable<LayerGeografici> {
      return this.http.get<LayerGeografici>(environment.apiWszUrl+`/multiPolygonGeoOnly?id=${id}&multiPolygonNomeEntita=${layer}`).pipe(
        retry(0),
        catchError(error => this.handleError(error))
      );
    }

    handleError(error: any) {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
      } else if (error.error.listaErrori) {
        // Get server-side error
        error.error.listaErrori.forEach((errorItem: { codiceErrore: string, descrizioneErrore: string }) => {
          this.snackbar.error(`Errore: ${errorItem.descrizioneErrore}`);
        });
      } else if (error.error.codiceErrore) {
        this.snackbar.error(`Errore: ${error.error.descrizioneErrore}`);
      } else if (error.error.error) {
        this.snackbar.error(`Errore: Mi dispiace, qualcosa non va. <br>(${error.error.status} - ${error.error.error})`)
      } else {
        this.snackbar.error(`Errore: Mi dispiace, il server non risponde.`)
      }
  
    return throwError(() => {
        return errorMessage;
      });
    }
}
